import { render } from "./RightStripIcon.vue?vue&type=template&id=4641d04c&scoped=true"
import script from "./RightStripIcon.vue?vue&type=script&lang=js"
export * from "./RightStripIcon.vue?vue&type=script&lang=js"

import "./RightStripIcon.vue?vue&type=style&index=0&id=4641d04c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4641d04c"]])

export default __exports__